import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ConfigAPI from '@/config/api'
import Session from '@/handler/session'

Vue.use(VueAxios, axios)

const instance = axios.create();

const servicesAPI = {
  obtener() {
    var url = ConfigAPI.baseURL + "settings";

    return instance.get(url);
  },
  restaurarBranding(target) {
    var url = ConfigAPI.baseURL + "settings/branding/restore" + Session.getToken();

    return instance.post(url, { target: target });
  },
  guardar(data, image1, image2, image3) {
    var headers = {
      'Content-Type': 'multipart/form-data'
    }

    var formData = new FormData();

    data = JSON.parse(data)
    for ( var key in  data) {
      if(key!="logo" && key!="favicon" && key!="imageLogin") {
        formData.append(key, data[key]); 
      }

      if(key=="logo") {
        let i = 0
        image1.forEach((value) => {
          formData.append('logo_' + i, value);
          i++
        })
        formData.append('logo', i);
      }

      if(key=="favicon") {
        let i = 0
        image2.forEach((value) => {
          formData.append('favicon_' + i, value);
          i++
        })
        formData.append('favicon', i);
      }

      if(key=="imageLogin") {
        let i = 0
        image3.forEach((value) => {
          formData.append('imageLogin_' + i, value);
          i++
        })
        formData.append('imageLogin', i);
      }
    }

    var params = formData

    var url = ConfigAPI.baseURL + "settings";

    return instance.post(url,params,{headers});
  },
}

export default servicesAPI;
